import React from 'react';
const Orders: React.FC = () => (
  <div className='text-2xl font-bold'>Orders Manager (Stub Page)</div>
);
export default Orders;
